import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PossibleQuoteyScoreValues } from "../store/helperfuncs";
import LoadingScoreBar from "./LoadingScoreBar";
import ScoreBar from "./ScoreBar";
import _ from "lodash";

const RscoreDeciderComp = (props) => {
  const { responseid, showLoading } = props;
  const [show, setShow] = useState(true);
  // const dispatch = useDispatch();

  const quoteyscore = useSelector(
    (state) => state.entities.quotes.responsedetails[responseid]["quoteyscore"]
  );

  // useEffect(() => {
  //   const timeout = setTimeout(() => setShow(true), _.random(3000, 10000));
  //   return () => clearTimeout(timeout);
  // });

  let loadingbar = <LoadingScoreBar text={"Calculating..."}></LoadingScoreBar>;

  const deciderDiv = () => {
    if (showLoading) return loadingbar;
    if (show) {
      if (quoteyscore === PossibleQuoteyScoreValues.loading) {
        return loadingbar;
      } else if (quoteyscore === 0 || quoteyscore === null)
        return <ScoreBar score={0}></ScoreBar>;
      else return <ScoreBar score={quoteyscore}></ScoreBar>;
    } else {
      return loadingbar;
    }
  };
  return deciderDiv();
};

export default RscoreDeciderComp;
